export default "__VITE_ASSET__g9vof2I1__"